import {
  GlobalCustomSVGStyles as OrcsGlobalCustomSVGStyles,
  setupFontAwesome as setupOrcsFontAwesome,
} from "orcs-design-system";

export const GlobalCustomSVGStyles = OrcsGlobalCustomSVGStyles;

const setupFontAwesome = () => {
  setupOrcsFontAwesome();
};

export default setupFontAwesome;
